module.exports = __webpack_public_path__ + "img/small-green-semi-circle.cbf226d0.svg";